$(document).ready(function(){
    $('#btn-search').on('click', function(){
        $('#address-search')[0].setCustomValidity('')
        var query = $('#address-search').val();
        if(query){
            $('.js_shippingChoice').prop('checked', true);
            getSuggestionsWithQuery(query);
        } else {
            $('#zip-search')[0].setCustomValidity('Veuillez saisir une adresse.')
            $('#zip-search')[0].reportValidity();
        }
    });

    $('#btn-gps').on('click', function(){
        if ("geolocation" in navigator){ //check geolocation available 
            navigator.geolocation.getCurrentPosition(function(position){ 
                getSuggestionsWithCoord(position.coords.latitude, position.coords.longitude);
                getAdressFromCoord(position.coords.latitude, position.coords.longitude)
            });
        }
    });

    $('.js_shippingChoice').on('change', function() {
        changeRequiredShipping($(this))
    });

    $('#zip-search').on('keypress', function(event){
        let keycode = event.keyCode || event.which;
        if(keycode === 13){
            event.preventDefault()
            $('#btn-search').trigger('click');
        }
    });
});

function changeRequiredShipping(element){
    $('input,textarea,select').filter(`[data-required!='${element.attr('id')}'][data-required]`).prop('required', false);
    $('input,textarea,select').filter(`[data-required='${element.attr('id')}'][data-required]`).prop('required', true);
    // Modification prix livraison
    $('#shippingPredictDefaultPrice').val(element.data('price-shipping'))
    // Vérification afin de retirer les suggestions si c'est sur du home
    if (element.attr('id') == 'home-shipping') {
        $("[name^='relay_dpd']").prop('checked', false);
    }
    deliveryCalcCart()
}

function deliveryCalcCart(){
    // Price change
    let subTotalPrice = $('#totalFixedCart').val()
    let fullTotalPrice = $('#ht_total-price').val()
    let price = $('#shippingPredictDefaultPrice').val()
    // Modification des prix
    $('.price-shipping-detail').text(price)
    // total = parseFloat(subTotalPrice) + parseFloat(price)
    // $('.totalPriceTTC').text((Math.round(total * 100) / 100).toFixed(2))
    totalHt = parseFloat(subTotalPrice) + parseFloat(price)
    $('.totalPriceHT').text(totalHt.toFixed(2))
    totalTtc = (parseFloat(fullTotalPrice) + parseFloat(price))
    $('.totalPriceTTC').text(totalTtc.toFixed(2))
}

function getSuggestionsWithQuery(query) {
    $.ajax({
        url: 'https://api-adresse.data.gouv.fr/search/',
        type: 'GET',
        data: {'q': query, 'limit':1},
        success: function(data){
            if (data != 'ko'){
                let longitude = (data.features[0].geometry.coordinates[0]);
                let latitude  = (data.features[0].geometry.coordinates[1]);
                $('#address-search').val(data.features[0].properties.label);

                getSuggestionsWithCoord(latitude, longitude);
            }
        }
    });
}

function getSuggestionsWithCoord(latitude, longitude) {
    $.ajax({
        url: route('relay.get'),
        type: 'GET',
        data: {'lon': longitude, 'lat': latitude},
        success: function(data){
            if (data != 'ko'){
                $('.search-dpd-result').html(data);
                changeRequiredShipping($('.js_shippingChoice:checked').first())
            }
        }
    });
}

function getAdressFromCoord(latitude, longitude) {
    $.ajax({
        url: 'https://api-adresse.data.gouv.fr/reverse/',
        type: 'GET',
        data: {'lon': longitude.toFixed(2), 'lat': latitude.toFixed(2), 'limit':1},
        success: function(data){
            if (data != 'ko'){
                let label = (data.features[0].properties.label);
                $('#address-search').val(label);
            }
        }
    });
}
